import React, { useMemo } from "react";

// Components
import { SEO } from 'components/core/seo';
import { useTranslation } from "react-i18next";
import { Heading, TextError } from "components/core/typo";
import { useSearch } from "hooks/useSearch";
import { searchDocuments } from "api/utils";
import { Skeleton } from "components/core/skeleton";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { Button } from "components/core/button";
import { EmptyState } from "components/core/empty";
/*
  Documents base page
*/

function DocumentItem({name, description, num_bytes, url}){
    const {t} = useTranslation("common");
    return <div className="flex items-center w-full space-x-3 md:space-x-5">
            <div>
                <DocumentTextIcon className="w-8 h-8 mr-3 text-gray-400" aria-hidden="true" />
                </div>
            <div className="mr-auto flex-1">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                    {name}
                </h3>
                <p className="text-gray-500">{description}</p>
                <p className="font-medium text-gray-500">{num_bytes}</p>
            </div>
            <Button color="inlineLink" size="link" href={url} className='ml-auto text-right'>{t("download")}</Button>
            </div>
}

function DocumentsPage(){
  const {t} = useTranslation("common");
  const params = useMemo(()=>({}), []);
  const [documents, {error}] = useSearch(searchDocuments, params)
  return <div className="px-6 ">
            <SEO title={"documents.title"} description={"documents.description"} />
            <Heading title={t("documents.title")}/>
            {!documents?
                <Skeleton className={"h-24"}/>:
            documents.length===0?
                <EmptyState title={t("no-documents.title")} description={t("no-documents.description")}/>
                :
                <div className="w-full max-w-3xl p-6 space-y-6 lg:space-y-12">
                    {documents.map((d, i)=><DocumentItem key={i} {...d}/>)}
                </div>
            }
            {error && <TextError {...error}/>}
         </div>
}

export {DocumentsPage}